import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import mpsLogo from '../../assets/images/mps_logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-top mt-auto py-2 brand-app-footer">
      <Container fluid>
        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start">
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <img 
                src={mpsLogo} 
                alt="Enable LXP Logo" 
                style={{ width: 48, height: 32, marginRight: 8, objectFit: 'contain' }}
              />
              <div>
                <div className="fw-bold mb-0 brand-app-footer-title" style={{ fontSize: 14 }}>Enable LXP</div>
                <div className="text-muted" style={{ fontSize: 12 }}>
                  © {currentYear} Learning Experience Platform. All rights reserved.
                </div>
              </div>
            </div>
          </Col>
          <Col md={6} className="text-center text-md-end mt-2 mt-md-0">
            <div className="d-inline-flex flex-wrap justify-content-center justify-content-md-end gap-2" style={{ fontSize: 12 }}>
              <Link to="/user/terms" className="text-decoration-none text-muted hover:text-purple-600 transition-colors">
                Terms of Use
              </Link>
              <span className="text-muted">|</span>
              <Link to="/user/privacy" className="text-decoration-none text-muted hover:text-purple-600 transition-colors">
                Privacy Policy
              </Link>
              <span className="text-muted">|</span>
              <Link to="/user/faqs" className="text-decoration-none text-muted hover:text-purple-600 transition-colors">
                FAQ
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;